export default __webpack_public_path__ + "static/media/home.e74eb93b.svg";